import { Box } from '@mui/material'
import DOMPurify from 'dompurify'
import React, { useMemo } from 'react'
import ListModule from '../module/ListModule'
import { textOperators, equalityOperators, multiselectOperators, dateOperators } from '../../utils/constants/operators'
import { emailType } from '../../utils/constants/misc'

const EmailSubModule = ({ userRight, customer, user }) => {
  const options = useMemo(
    () => ({
      tableStyle: { maxHeight: 350, padding: '1px' },
      paperStyle: {},
      accessRight: userRight,
      actions: { email: true },
      objectType: 'emailsFiltered',
      objectName: 'emails',
      objectFilter: () => ({
        $and: [
          { company_id: customer?.company_id },
          { $not: [{ folder: 'TRASH' }] },
          {
            $or: [
              { $and: [{ type: 'outbound' }, { toEmail: { $regex: customer?.email } }] },
              { $and: [{ type: 'inbound' }, { fromEmail: customer?.email }] },
              { $and: [{ type: 'outbound' }, { ccEmail: { $regex: customer?.email } }] }
            ]
          }
        ]
      }),
      isExpand: true,
      isFilter: true,
      expand: (item) => (
        <Box
          sx={{ width: '100%' }}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(item?.html || '')
          }}
        />
      ),
      columns: [
        {
          name: 'type',
          label: 'Entrant/Sortant',
          isFilter: true,
          valueEditorType: 'multiselect',
          values: emailType,
          mapping: (id) => emailType.find((item) => item?.id === id)?.label || id,
          operators: [...equalityOperators, ...multiselectOperators]
        },
        { name: 'subject', label: 'Sujet', isFilter: true, operators: textOperators },
        { name: 'toEmail', label: 'Adresse email' },
        {
          name: 'datetime',
          label: 'Date',
          isFilter: true,
          inputType: 'datetime-local',
          type: 'date',
          format: 'DD/MM/YYYY HH:mm',
          operators: dateOperators
        }
      ]
    }),
    [customer?.company_id, customer?.email, userRight]
  )

  const toolbar = useMemo(
    () => ({
      isFilter: true,
      isSubMod: true,
      columns: options.columns,
      style: { marginTop: '5px', marginBottom: '5px' },
      accessRight: userRight,
      actions: { sendMail: true },
      getContext: () => ({ toEmail: [customer?.email], fromEmail: user?.email }),
      columnVisibility: true
    }),
    [customer?.email, user?.email, options.columns, userRight]
  )

  return <ListModule options={options} toolbar={toolbar} />
}

export default React.memo(EmailSubModule)
